import { fetchFlight } from '@/api/flight'

const getFlight = (context) => {
  fetchFlight().then((response) => {
    if (_.isEmpty(response) || !response?.success) {
      return response
    }
    context.commit('FLIGHT_UPDATED', response.data)
    context.commit('FLIGHTLEGS_UPDATED', response.flightLegs)
  })
}

export default {
  getFlight
}
